








import Api from "@/api/Api";
import { Advertisement } from "@/interfaces/advertisement";
import randomstring from "randomstring";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    async exec() {
      if (!this.advertisement) {
        return;
      }
      const api = Api.singleton();

      await api.call({
        method: "PUT",
        resource: this.advertisement["@id"] + "/preview_token",
        body: {
          previewToken: randomstring.generate(64)
        }
      });
      this.$emit("success");
    }
  }
});
